import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
} from 'reactstrap';
import { Field } from '@cordata/buffet';
import { useFormikContext } from 'formik';

import CareEventNoteListGroup from '~/components/Note/CareEventNoteListGroup';

import { store } from '~/utils/diagnosis';

const DiagnosisFormFields = ({
  isAdd,
  disabled,
}) => {
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    diagnoses: [],
    providers: [],
    statuses: [],
  });

  const {
    values,
    setFieldValue,
  } = useFormikContext();

  const [regions, setRegions] = useState([]);

  useEffect(() => {
    store.getFormData()
      .then(setFormData)
      .then(() => setLoading(false));
  }, []);

  useEffect(() => {
    const diagnosisUid = values.diagnosis?.id || values.diagnosis?.diagnosisUid;
    const selectedRegionUid = values.region?.id;

    if (diagnosisUid) {
      store.getRegions(diagnosisUid)
        .then(r => {
          setRegions(r);

          if (!r.some(region => region.id === selectedRegionUid)) {
            setFieldValue('region', null);
          }
        });
    }
  }, [values, values.diagnosis]);

  return (
    <>
      <Row form>
        <Col>
          <Field
            name="diagnosis"
            type="select"
            getOptionValue={o => o.diagnosisUid}
            getOptionLabel={o => o.diagnosisLabel}
            options={formData.diagnoses}
            loading={loading}
            required
            disabled={disabled}
          />
        </Col>

        <Col>
          <Field
            name="region"
            type="select"
            getOptionValue={o => o.id}
            getOptionLabel={o => o.attributes?.regionLabel}
            options={regions}
            loading={loading}
            disabled={disabled}
          />
        </Col>
      </Row>

      <Row form>
        <Col>
          <Field
            name="onsetDate"
            type="date"
            disabled={disabled}
          />
        </Col>

        <Col>
          <Field
            name="status"
            type="select"
            getOptionValue={o => o.statusUid}
            getOptionLabel={o => o.statusLabel}
            options={formData.statuses}
            loading={loading}
            required
            disabled={disabled}
          />
        </Col>
      </Row>

      <Row form>
        <Col>
          <Field
            name="provider"
            type="select"
            getOptionValue={o => o.id}
            getOptionLabel={o => o.attributes.displayName}
            options={formData.providers}
            loading={loading}
            required
            disabled={disabled}
          />
        </Col>

        <Col>
          <Field
            name="isPrimaryDiagnosis"
            label="Primary Diagnosis"
            placeholder=" " // hide redundant label
            text="Check this if this diagnosis is of primary interest to this specialty and should be highlighted for all care team members"
            type="checkbox"
            disabled={disabled}
          />
        </Col>
      </Row>

      <Field
        name="note"
        label="Notes"
        type="textarea"
        disabled={disabled}
      />

      {!isAdd && values.relationships?.notes.length > 0 && (
        <>
          <hr className="my-5" />

          <CareEventNoteListGroup notes={values.relationships?.notes} />
        </>
      )}
    </>
  );
};

DiagnosisFormFields.propTypes = {
  disabled: PropTypes.bool,
  isAdd: PropTypes.bool,
};

DiagnosisFormFields.defaultProps = {
  disabled: false,
  isAdd: false,
};

export default DiagnosisFormFields;
